const module = {
  config: {
    name: 'news-archieve-module',
    icon: 'ri-user-line',
    desc: '',
    group: 'Postingan Diarsipkan',
    layout: true
  },
  routes: [
    { name: 'news-archieve', label: 'Berita', icon: 'ri-file-text-line', path: '/news-archieve', component: () => import('./news-archieve.vue') }
    // { name: 'news', label: 'Berita', icon: 'ri-skip-right-fill', path: '/news', component: () => import('./users.vue') }
  ]
}
export default module



// WEBPACK FOOTER //
// ./src/modules/news-archieve/_index.js